import { type FC } from 'react';
import { graphql, useFragment } from 'react-relay';
import { dibsLazyClient } from 'dibs-lazy/exports/dibsLazyClient.ts';
import { VisibilityTracker } from 'dibs-visibility-tracker/exports/VisibilityTracker.tsx';
import { filterFalsy } from 'dibs-ts-utils/exports/filterFalsy.ts';
import {
    isHp2TowerModelTestVariant,
    trackHp2TowerModelTest,
} from '../helpers/twoTowerModelTestHelpers.ts';
import { type HpSharedUserRecommendations_user$key } from './__generated__/HpSharedUserRecommendations_user.graphql.ts';

const userFragment = graphql`
    fragment HpSharedUserRecommendations_user on User {
        serviceId
        twoTowerModelItemRecommendations {
            recommendationIds
        }
    }
`;

const HpSharedUserRecommendationsGrid = dibsLazyClient(
    () =>
        import(
            /* webpackChunkName: "HpSharedUserRecommendationsGrid" */ './HpSharedUserRecommendationsGrid.tsx'
        )
);

type HpSharedUserRecommendationsProps = {
    user: HpSharedUserRecommendations_user$key | null;
};

export const HpSharedUserRecommendations: FC<HpSharedUserRecommendationsProps> = ({
    user: userRef,
}) => {
    const user = useFragment(userFragment, userRef);
    const userId = user?.serviceId;
    const recommendationIds = (
        user?.twoTowerModelItemRecommendations?.recommendationIds || []
    ).filter(filterFalsy);
    const hasRecommendations = recommendationIds.length > 0;

    if (!userId || !hasRecommendations) {
        return null;
    }

    const isVariant = isHp2TowerModelTestVariant();

    return (
        <>
            <VisibilityTracker
                onVisibilityChange={({ isVisible }) => {
                    if (isVisible) {
                        trackHp2TowerModelTest();
                    }
                }}
            />

            {isVariant && (
                <HpSharedUserRecommendationsGrid itemIds={recommendationIds} userId={userId} />
            )}
        </>
    );
};
